import { MutationCallbacks } from '../../../shared/types/mutation';
import useFetch from '../useFetch';
import { FetchKeys } from '../../../shared/constants/queries';
import {
  getReportsData,
  getReportsDownloadData,
  getReportsGenerateData,
} from '../../../shared/service/data';

export function useReportsData({
  enable,
  onSuccess,
  onError,
}: MutationCallbacks) {
  return useFetch([FetchKeys.reportsData], () => getReportsData(), {
    enabled: enable,
    onSuccess,
    onError,
  });
}

export function useReportsGenerateData(
  generateReportArgs: any,
  filters: any,
  { enable, onSuccess, onError }: MutationCallbacks,
) {
  return useFetch(
    [FetchKeys.reportGenerateData, generateReportArgs],
    () => getReportsGenerateData(generateReportArgs, filters),
    {
      enabled: enable,
      onSuccess,
      onError,
    },
  );
}

export function useReportsDownloadData(
  downloadReportArgs: any,
  { enable, onSuccess, onError }: MutationCallbacks,
) {
  return useFetch(
    [FetchKeys.reportDownloadData, downloadReportArgs],
    () => getReportsDownloadData(downloadReportArgs),
    {
      enabled: enable,
      onSuccess,
      onError,
    },
  );
}
